import { render, staticRenderFns } from "./ShareholderInd.vue?vue&type=template&id=804ee3b2"
import script from "./ShareholderInd.vue?vue&type=script&lang=js"
export * from "./ShareholderInd.vue?vue&type=script&lang=js"
import style0 from "./ShareholderInd.vue?vue&type=style&index=0&id=804ee3b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports